import { Avatar, AvatarFallback, AvatarImage } from '@ui/web/components'
import { getInitials } from '@helper/utils/format'

interface SchoolClassAvatarProps {
  name: string
  /** `team.image` — one of `schoolClassAvatarList`, or null for a class created before avatars. */
  image?: string | null
  size?: 'sm' | 'default' | 'lg'
  className?: string
}

/**
 * Avatar of a school class (a `team` row), shown wherever a class is picked or named.
 *
 * A class is recognized by its avatar as much as by its name — the avatar is what the teacher
 * chose in Buat/Edit kelas — so every class-selecting control renders the same square
 * `organization` avatar. Rendering one as a circle would read as a person, and a raw `<img>`
 * leaves classes without an avatar blank instead of falling back to their initials.
 */
export function SchoolClassAvatar({ name, image, size = 'sm', className }: SchoolClassAvatarProps) {
  return (
    <Avatar profile='organization' size={size} className={className}>
      {image && <AvatarImage src={image} alt={name} />}
      <AvatarFallback>{getInitials(name)}</AvatarFallback>
    </Avatar>
  )
}
